import { ChangeDetectionStrategy, Component, OnInit, ViewChildren } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { SOCUsersConfigService } from 'app/infrastructure/services/socUserConfig.service';
import { CustomBlockAtributoComponent } from '../../helpers/components/customAttributeBlock/customBlockAttribute.component';
import { ResponseInvocacionUsuario, ResponseConfiguration, VariableCircuitoIn, VariableCircuitoOut, UsuariosService } from '../../infrastructure/services/usuarios.service';
import { Observable } from 'rxjs';
import { saveAs } from 'file-saver';
import { OutputResultRequest } from 'app/infrastructure/model/classes/output.classes';
import { TableIcon, ActionButtons, ActionButton } from 'app/infrastructure/model/interfaces/dataTable.interface';
import { Role } from 'app/infrastructure/model/classes/role.class';
import { OpcionCheckeable } from 'app/infrastructure/services/selects.service';
import { SxTranslationService } from 'app/infrastructure/services/translation-service.service';

@Component({
  selector: 'sx-comandos-users-soc',
  templateUrl: 'comandos.users-soc.component.html'
})

export class ComandosUsersSocComponent implements OnInit {
  codServicio = 'SrvUsuario';
  mode: 'Form' | 'UsersAdmin' | 'Design' | 'Rule' | null;
  comandos;

  @ViewChildren('customBlocks') customBlocks: CustomBlockAtributoComponent[];
  codSistema = null;
  codNegocio = null;
  atributos;
  values = {};
  errores = {};
  mostrarRespuesta = false;
  adminUserName: string;
  respuestaListado: {
    headers: string[],
    filas: any,
  } = {
      headers: [],
      filas: [],
    };

  respuestaInvocacion: ResponseInvocacionUsuario;
  querySettings: OutputResultRequest;
  items: Observable<any> = new Observable<any>();
  Users: any;
  roles: OpcionCheckeable[] = [];
  filterRoles: OpcionCheckeable[] = [];


  constructor(private aRoute: ActivatedRoute,
    private router: Router,
    private usuariosService: UsuariosService,
    private comandosService: SOCUsersConfigService,
    private sxTranslationService: SxTranslationService) { }

  ngOnInit() {
    this.aRoute.params.subscribe((params: Params) => {
      this.mode = params['mode'];
      if (this.mode === undefined) {
        this.mode = 'Form';
      }
      if (this.mode === 'UsersAdmin') {

        this.querySettings = new OutputResultRequest();
        this.querySettings.status = null;

        this.querySettings.dataTableConfig = {
          codSistema: this.codSistema,
          page: 1,
          pageSize: 10,
          sortField: 'outputCode',
          sortDirection: 'desc',
          idTransaccion: null,
          columnConfig: [],
        };

        this.usuariosService.getFormulario(null, null, 'Listado', undefined)
          .then(response => {
            this.inicializarFormulario(response);
            this.usuariosService
            .invocarComando(this.codSistema, this.codNegocio, 'Listado', null, [])
            .then(res => {
              // La invocacion del comando fallo
              if (res.errores.length > 0) {
                this.mostrarErrores(res.errores);
                return;
              }
      
              // Invocacion del comando exitosa
              this.respuestaInvocacion = res.result;
      
              // Si es listado, debemos hacer un tratamiento especial para obtener los
              // datos que vienen en la respuesta
              this.parsearRespuestaListado(this.respuestaInvocacion.infoUsuario);
              /* (this.respuestaListado.filas as any[]).forEach(f => {
                Object.keys(f).forEach(k => {
                  f[k].statusIcon = this.mapStatusToIcon(f.status);
                })
              } ); */
              this.items = Observable.of({ items: this.respuestaListado.filas });
              this.Users = this.items;
              this.mostrarRespuesta = true;
            });
          
          });
      } else {
        this.comandos = this.comandosService.getConfiguration(this.mode);
      }
    });


  }

  inicializarFormulario(response: ResponseConfiguration) {
    this.atributos = response.form;
    this.mapRolesResponse(response.roles);
    this.adminUserName = response.adminUser;
    this.querySettings.dataTableConfig.columnConfig.push({
      title: 'Id',
      property: 'USR_IDUSUARIO',
      sortable: true,
      sortField: 'USR_IDUSUARIO'
    });
    this.querySettings.dataTableConfig.columnConfig.push({
      title: this.sxTranslationService.getResource('ESTADO'),
      property: 'USR_CodEstado',
      sortable: true,
      sortField: 'USR_CodEstado',
      displayMapping: (val) => this.statusDisplayMapping(val)
    });
    this.atributos.forEach(atributo => {
      if (atributo.tipo !== 'Custom') {
        this.values[atributo.codigo] = atributo.valorDefault;
      }
      if (atributo.tipo === 'DateTime') {
        this.values[atributo.codigo] = atributo.valorDefault; // .split('/').reverse().join('-')
      }
      this.querySettings.dataTableConfig.columnConfig.push({
        title: atributo.titulo,
        property: atributo.codigo,
        sortable: true,
        sortField: atributo.codigo
      });
    });
  }

  mapRolesResponse(roles: Role []){
    roles.forEach(rol => {
      this.roles.push({id: rol.roleCode, seleccionado: false, descripcion: rol.description})
    });
  }

  private statusDisplayMapping(val: any) { 
    return `USR_CodEstado_${val != null ? val : 'INVALID'}`;
  }

  /**
   * Formatea un date obtenido de un input html
   * a un formato compatible con Datetime del backend
   * y lo almacena en el la lista de values
   *
   * @param value Valor proveniendo del input date (YYYY-MM-DD)
   * @param codigoAtributo Key para saber que campo se esta actualizando
   */
  formatDate(value, codigoAtributo) {
    const splitedDate = value.split('-');
    this.values[codigoAtributo] = value; // splitedDate.reverse().join('/');
  }

  /**
   * Wrapper de la funcion JSON.parse para poder
   * utilizarla dentro del template html
   */
  toObj(json: string) {
    return JSON.parse(json);
  }

  mostrarErrores(errores) {
    errores.forEach(error => {
      /* this.alertService.showGrowl({
        body: error.errorMessage,
        type: GrowlType.DANGER,
      }); */
    });
  }

  seleccionarOpcion(codigo, opcion) {
    this.values[codigo] = opcion.value;
  }

  enviar() {
    let form: VariableCircuitoIn[] = Object.keys(this.values).map(key => ({ codigo: key, valor: this.values[key] }));

    if (!this.formularioValido(form)) {
      return;
    }

    // TODO: validar customb blocks
    this.customBlocks.forEach(block => {
      const variables = block.getValues();
      form = [...form, ...variables];
    });

    this.mostrarRespuesta = false;
    this.items = null;
    this.respuestaListado.filas = [];

    let requestedRoles = [];

    if (this.roles) {
      this.filterRoles.forEach(rol => rol.seleccionado == true && requestedRoles.push(rol.id));
    }

    this.usuariosService
      .invocarComando(this.codSistema, this.codNegocio, 'Listado', form, [])
      .then(res => {

        // La invocacion del comando fallo
        if (res.errores.length > 0) {
          this.mostrarErrores(res.errores);
          return;
        }

        // Invocacion del comando exitosa
        this.respuestaInvocacion = res.result;


        // Si es listado, debemos hacer un tratamiento especial para obtener los
        // datos que vienen en la respuesta
        this.parsearRespuestaListado(this.respuestaInvocacion.infoUsuario);
        /* (this.respuestaListado.filas as any[]).forEach(f => {
          Object.keys(f).forEach(k => {
            f[k].statusIcon = this.mapStatusToIcon(f.status);
          })
        } ); */
        this.items = Observable.of({ items: this.respuestaListado.filas });
        this.mostrarRespuesta = true;
      });
  }

  /**
   * Crea la estructura que se usara para llenar la tabla con
   * el listado de usuarios a partir de la respuesta que proviene
   * de la llamada a la invocacion del comando Listado
   *
   * @param listado
   */
  parsearRespuestaListado(listado: VariableCircuitoIn[]) {
    // Si no hay usuarios, no hay nada que hacer
    if (listado.length <= 0) {
      this.respuestaListado.filas = [];
      return;
    }

    // Parseamos cada usuario
    const listadoParseado = listado.map(variableIn => {
      const variableParseada = JSON.parse(variableIn.valor);
      const valorParseado = JSON.parse(variableParseada.Valor);
      return valorParseado;
    });

    // Buscamos el usuario que tenga la mayor cantidad de campos
    // para armar el header de la tabla con sus campos
    let maxCampos = 0;
    let usuarioConMasCampos = listadoParseado[0];
    listadoParseado.forEach(campos => {
      if (campos.length > maxCampos) {
        maxCampos = campos.length;
        usuarioConMasCampos = campos;
      }
    });

    // Nos quedamos solo con el codigo
    this.respuestaListado.headers = usuarioConMasCampos.map(valor => valor.Codigo);


    // Cada usuario es convertido en una fila, y cada atributo en una columna
    listadoParseado.forEach(value => {
      const fila = [];
      value.forEach(val => {
        if ((this.atributos as any[]).find(a => a.codigo === val.Codigo) 
            || val.Codigo === 'USR_IDUSUARIO' || val.Codigo === 'USR_CodEstado') {
          fila[val.Codigo] = val.Valor;
        }
      });
      this.respuestaListado.filas.push(fila);
    });
  }

  /**
   * Valida cada campo del formulario, checkeando los que
   * son obligatorios. Retorna true solo si cada campo
   * obligatorio fue ingresado.
   */
  formularioValido(form: VariableCircuitoIn[]): boolean {
    this.errores = {};
    return this.atributos
      .map(this.campoValido.bind(this, form))
      .reduce((current, total) => current && total);
  }

  /**
   * Valida que el atributo pasado sea valido.
   */
  campoValido(form: VariableCircuitoIn[], atributo: VariableCircuitoOut): boolean {
    let esValido = true;
    const variable = form.find(atr => atr.codigo === atributo.codigo);

    if (!variable) {
      return true;
    }

    const valor = variable.valor;

    if (!atributo.esOpcional) {
      esValido = !!valor;
      if (!esValido) {
        this.errores[atributo.codigo] = 'VALOR_REQUERIDO';
      }
    }

    return esValido;
  }

  Sort(sortField, sortDirection) {
    this.Users.value.items.sort((a, b) => {
      if(a[sortField] != null && b[sortField] != null){
        const isNumber = /^\d+$/.test(a[sortField]);
        if(isNumber){
          const number1 = Number(a[sortField]);
          const number2 = Number(b[sortField]);

          return sortDirection === 'asc'
          ? (number1 > number2) ? 1 : -1
          : (number1 > number2) ? -1 : 1
        }
        else {
          return sortDirection === 'asc'
          ? (a[sortField].toLowerCase() > b[sortField].toLowerCase()) ? 1 : -1
          : (a[sortField].toLowerCase() > b[sortField].toLowerCase()) ? -1 : 1         
        }
      }
    });
  }

  mapStatusToIcon(statusCode: number): TableIcon {
    const icon: any = {
      tooltip: statusCode
    };

    if (statusCode !== 1) {
      icon.iconClass = 'fa-times-circle text-danger';
    } else {
      icon.iconClass = 'fa-check-circle text-success';
    }

    return icon as TableIcon;
  }

  fetchData(event) {
    if (event.sortField && event.sortDirection) {
      this.querySettings.dataTableConfig.sortDirection = event.sortDirection;
      this.querySettings.dataTableConfig.sortField = event.sortField;
    }

    this.Sort(event.sortField, event.sortDirection);
  }

  handleActions(event: { row: any, actionId: string }) {
    this.router.navigate([event.actionId, event.row['USR_IDUSUARIO']], { relativeTo: this.aRoute });
  }

  actionMapping(row: any): ActionButtons {
    const actions = [];

    actions.push({
      iconClass: 'fa-pencil-alt-square-o',
      actionId: 'usersAdmin/Edicion',
      tooltip: 'EDITAR'
    } as ActionButton);

    actions.push({
      iconClass: 'fa fa-user',
      actionId: '../../userProfilesAdmin',
      tooltip: 'EDITAR_ROL'
    } as ActionButton);

    actions.push({
      iconClass: 'fa-ban',
      actionId: 'usersAdmin/Bloqueo',
      tooltip: 'BLOQUEAR'
    } as ActionButton);

    actions.push({
      iconClass: 'fa-trash',
      actionId: 'usersAdmin/Delete',
      tooltip: 'ELIMINAR'
    } as ActionButton);

    actions.push({
      iconClass: 'fa-recycle',
      actionId: 'usersAdmin/Blanqueo',
      tooltip: 'BLANQUEO'
    } as ActionButton);

    actions.push({
      iconClass: 'fa-key',
      actionId: 'usersAdmin/CambioPassword',
      tooltip: 'CAMBIO_CLAVE'
    } as ActionButton);


    return actions;
  }

  exportList() {
    const form: VariableCircuitoIn[] = Object.keys(this.Users.value.items).map(key => ({ codigo: key, valor: this.Users.value.items[key] }));

    if (!this.formularioValido(form)) {
      return;
    }

    this.usuariosService.exportListToExcel(this.codSistema, this.codNegocio, form)
      .then(response => this.downloadExcelFile(response));
  }

  downloadExcelFile(data) {

    // base64 To ArrayBuffer
    const binaryString = atob(data.fileContents);
    const binaryLen = binaryString.length;
    const bytes = new Uint8Array(binaryLen);
    for (let i = 0; i < binaryLen; i++) {
      const ascii = binaryString.charCodeAt(i);
      bytes[i] = ascii;
    }

    this.download(bytes, data.fileDownloadName, data.contentType);
  }

  download(content, filename, contentType) {
    const blob = new Blob([content], { 'type': contentType });
    saveAs(blob, filename);
  }

  applyRolesFiltered(roles: OpcionCheckeable[]) {
    this.filterRoles = roles;
  }
}


// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/users-soc/comandos.users-soc.component.ts